<template>
  <div
    class="info-card tw-flex tw-flex-col tw-gap-4 tw-py-3"
    :style="`background-color: var(--${vars.backgroundColor})`"
  >
    <div class="tw-w-full">
      <LibraryImage
        v-if="vars.photoImage"
        :src="vars.photoImage"
        :alt="vars.titleText"
        image-class="tw-h-full tw-w-full tw-object-cover"
        style="border-radius: var(--rounded)"
      />
      <library-iframe v-else-if="vars.videoUrl" :src="vars.videoUrl" />
    </div>
    <h3 class="tw-relative tw-text-2xl tw-font-semibold">{{ vars.titleText }}</h3>
    <p>{{ vars.descriptionText }}</p>
    <div v-if="vars.buttonLabelText" class="tw-mt-4 tw-flex tw-items-center tw-justify-start">
      <nuxt-link
        :to="vars.buttonLinkUrl"
        :class="`n-${vars.buttonTypeText} pxp-primary-cta pxp-animate after:tw-border-t-[var(--akya-background-color)]`"
        style="color: var(--akya-background-color); border-top-color: var(--akya-background-color)"
        >{{ vars.buttonLabelText }}</nuxt-link
      >
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'InfoCard',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {},
    };
  },
});
</script>
